export const toPerPoint = (value: number, points: number) => +(value / points).toFixed(2);
export const toWholeSite = (value: number, points: number) => value * points;
